import { Menu } from '@mui/material';
import React, { useState } from 'react';
import { Download } from 'react-feather';
import { Fragment } from 'react/jsx-runtime';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import { ListItem } from 'src/components/Drawer/SidebarStyled';
import PopupExportData from 'src/components/ExportData/PopupExport';
import { LIST_FEATURES } from 'src/utils/constants/featuresPoint';

export interface IExportTradeDataTableProps {
  totalRecordsAvailable: number;
  featureId?: keyof typeof LIST_FEATURES;
  endpoint?: string;
  fileName?: string;
  paramsExport?: Record<string, ExpectedAny>;
}
const ExportDataTable = (props: IExportTradeDataTableProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [visiblePopup, setVisiblePopup] = useState({
    visible: false,
    fileType: 'csv',
  });
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setVisiblePopup((prev) => ({ ...prev, visible: false }));
  };

  const open = Boolean(anchorEl);

  const onSelect = (type: string) => {
    setVisiblePopup((prev) => ({ ...prev, fileType: type, visible: true }));
  };

  return (
    <Fragment>
      <ButtonWithLoading onClick={handleClick} startIcon={<Download size={18} />} variant="outlined" color="inherit">
        Export Data
      </ButtonWithLoading>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <ListItem onClick={() => onSelect('csv')} key={'CSV'}>
          Export as CSV
        </ListItem>
        <ListItem onClick={() => onSelect('xlsx')} key={'XLSX'}>
          Export as XLSX
        </ListItem>
      </Menu>
      <PopupExportData
        {...props}
        fileType={visiblePopup.fileType}
        open={visiblePopup.visible}
        handleClose={handleClose}
      />
    </Fragment>
  );
};

export default ExportDataTable;
